import { FormControl, FormControlLabel, FormGroup, FormHelperText, IconButton, Stack, Switch, Tooltip, Typography, useMediaQuery } from '@mui/material'
import React, { FunctionComponent, SetStateAction } from 'react'
import gaiaTheme from '../../../../root-components/theme'
import FormEditButtons from './form-edit-buttons'
import { TooltipHover } from '../../miscellaneous-components/tooltip-hover'
import { InfoOutlined } from '@mui/icons-material'

export const FormToggleInputDisplay: FunctionComponent<{
  isEditPage: boolean,
  allowEdit?: boolean,
  editField?: string | undefined,
  setEditField?: React.Dispatch<SetStateAction<any>> | undefined,
  hideEditIcon?: boolean,
  disabled: boolean,
  isLastField?: boolean,
  title: string,
  name: string,
  value: boolean,
  touched?: any,
  errors?: any,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  cancelEditHandler?: () => void,
  customErrorMessage?: string,
  tooltip?: string,
  onInfoClick?: () => void,
  bottomBorder?: boolean,
  topBorder?: boolean,
  sideBorders?: boolean,
  isTopRow?: boolean,
  isBottomRow?: boolean,
}> = ({
  isEditPage,
  allowEdit = true,
  editField,
  setEditField,
  hideEditIcon = false,
  disabled,
  isLastField = false,
  title,
  name,
  value,
  touched,
  errors,
  onChange,
  cancelEditHandler,
  customErrorMessage,
  tooltip,
  onInfoClick,
  bottomBorder = false,
  topBorder = true,
  sideBorders = true,
  isTopRow = false,
  isBottomRow = false,
}) => {

    const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

    const toggleEditField = (fieldName: string) => {
      if (setEditField) {
        setEditField(fieldName)
      }
    }

    return (
      <FormControl fullWidth variant='outlined'>
        <Stack sx={{
          borderWidth: '1px',
          borderBottomStyle: bottomBorder || isBottomRow ? 'solid' : 'none',
          borderColor: 'lightGrey.main',
          borderLeftStyle: sideBorders ? 'solid' : 'none',
          borderRightStyle: sideBorders ? 'solid' : 'none',
          borderTopStyle: topBorder || isTopRow ? 'solid' : 'none',
          pt: 1, pb: 1, pl: 3,
          borderTopLeftRadius: isTopRow ? '10px' : 0,
          borderTopRightRadius: isTopRow ? '10px' : 0,
          borderBottomLeftRadius: isBottomRow ? '10px' : 0,
          borderBottomRightRadius: isBottomRow ? '10px' : 0
        }}>
          <Stack position='relative' alignItems={isMobileMode ? 'flex-start' : 'center'} flexDirection={isMobileMode ? 'column' : 'row'} justifyContent='start'>
            <Stack sx={{ width: isMobileMode ? '100%' : '40%', minWidth: '100px', color: 'text.primary', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant='subtitle1'>{title}</Typography>
            </Stack>
            <Stack position='relative' flexDirection='column' sx={{ width: '100%' }}>
              <Stack position='relative' flexDirection='row' justifyContent='start' alignItems='center'>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={value}
                        onChange={onChange}
                        name={name}
                        disabled={disabled}
                        color="primary"
                      />
                    }
                    label={
                      onInfoClick ? (
                        <Tooltip title={tooltip ?? 'More information'} placement='right'>
                          <IconButton onClick={onInfoClick} sx={{ ml: 1, color: 'text.secondary', p: 0, pt: '2px' }}>
                            <InfoOutlined />
                          </IconButton>
                        </Tooltip>
                      ) : tooltip ? (
                        <TooltipHover
                          title={title}
                          backgroundColor='white'
                          text={tooltip}
                          placement='right'>
                          <InfoOutlined sx={{ ml: 1, color: 'text.secondary', pt: 1 }} />
                        </TooltipHover>
                      ) : ""
                    }
                  />
                </FormGroup>
                {allowEdit &&
                  <FormEditButtons
                    isEditPage={isEditPage}
                    editField={editField}
                    hideEditIcon={hideEditIcon}
                    name={name}
                    toggleEditField={toggleEditField}
                    cancelEditHandler={cancelEditHandler}
                  />}
              </Stack>
              {touched && errors &&
                <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                  {errors ? <div>{errors as string}</div> : null}
                </FormHelperText>
              }
              {customErrorMessage &&
                <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>{customErrorMessage}
                </FormHelperText>
              }
            </Stack>
          </Stack>
        </Stack>
      </FormControl>
    )
  }